/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { dispatchClaimDetails } from '../../../Display/ClaimDetails/store/actions';
import { removeErr } from '../../../../SharedModules/utilities/utilities';
import { API_TIMEOUT_ERROR, FAILED_MESSAGE_GENERIC } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for Claim Audit screen
export const dispatchClaimAuditSelectTabData = (data) => ({
  type: actionTypes.GET_CLAIM_AUDIT_SELECT_SCREEN_OBJ,
  screenData: data,
});

export const dispatchSetClaimAuditSelectTabData = (payload) => ({
  type: actionTypes.SET_CLAIM_AUDIT_SELECT_SCREEN_OBJ,
  payload,
});
// dispatch function for tab data for Claim Audit Detail screen
export const dispatchClaimAuditDetailTabData = (data) => ({
  type: actionTypes.GET_CLAIM_AUDIT_DETAIL_SCREEN_OBJ,
  detailScreenData: data,
});

// dispatch all labeler data
export const dispatchLabelerData = (data) => ({
  type: actionTypes.GET_ALL_LABELER,
  payload: data,
});

export const getClaimCategoryCodeTable = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, {
      codeDomainList: ['CLAIM_CATEGORY_CD'],
    })
    .then((response) => {
      dispatch({ type: actionTypes.CLAIM_CATEGORY_CD, payload: response.data });
    })
    .catch((response) => {
      dispatch({ type: actionTypes.CLAIM_CATEGORY_CD, payload: null });
    });
};

// get labeler data from services
export const getAllLabelerData = (value) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_ALL_LABELER_LIST)
    .then((response) => {
      return dispatch(dispatchLabelerData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchLabelerData([]));
    });
};
//  error message dispatch function
export const dispatchErrorMsgForClaimAudit = (data) => ({
  type: actionTypes.GET_ERROR_MSG_FOR_CLAIM_AUDIT,
  payload: data,
});

//  dispatch function for rebate program dropdown
export const dispatchRebateProgram = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_DROPDOWN,
  payload: data,
});

// get Rebate Programe function
export const getRebateProgramDataMD = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response?.data?.data;
    })
    .catch(() => {
      return [];
    });
};

//  dispatch function for Specific Audit Type dropdown
export const dispatchSpecificAuditType = (data) => ({
  type: actionTypes.GET_SPECIFIC_AUDIT_TYPE_DROPDOWN,
  payload: data,
});

// get Rebate Programe function
export const getSpecificAuditTypeData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_AUDIT_TYPE_LIST, value)
    .then((response) => {
      return dispatch(dispatchSpecificAuditType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSpecificAuditType([]));
    });
};

//  dispatch function for Claim Audit Detail api
export const dispatchClaimAuditDetail = (data) => ({
  type: actionTypes.GET_CLAIM_AUDIT_DETAIL,
  payload: data,
});

// get function for Claim Audit Detail api
export const getClaimAuditDetailData = (value) => (dispatch, getState) => {
  return axios
    .post(serviceEndPoint.GET_SEARCH_CLAIM_AUDIT_DETAILS, value)
    .then((response) => {
      let newObj = [];
      const { data } = response;
      let tempObj = [];
      if (data.claimAuditResponse) {
        tempObj = data.claimAuditResponse
          .sort((a, b) =>
            `${a?.labelerCode}-${a?.productCode}-${a?.packageSize}` >
            `${b?.labelerCode}-${b?.productCode}-${b?.packageSize}`
              ? -1
              : 1
          )
          ?.map((item) => {
            item.ndc = `${item?.labelerCode}-${item?.productCode}-${item?.packageSize}`;
            return item;
          });
        if (tempObj?.length > 0) {
          tempObj.sort((a, b) => (a.paidDt > b.paidDt ? 1 : -1));
          newObj = [
            ...new Map(tempObj.map((item) => [item.ndc, item])).values(),
          ];
        }
      }
      // return dispatch(dispatchClaimAuditDetail(data));
      return { ...data, claimAuditResponse: newObj };
    })
    .catch((error) => {
      
            if (
              error.message === 'Network Error' ||
              error.message === 'Request failed with status code 502'
            ) {
              dispatch(dispatchErrorMsgForClaimAudit({
                "field": "",
                "errorType": "",
                "message": API_TIMEOUT_ERROR
            }));
            }else{
              dispatch(dispatchErrorMsgForClaimAudit({
                "field": "",
                "errorType": "",
                "message": FAILED_MESSAGE_GENERIC
            }));
              // setTimeout(() => {
                // const state = getState();
                // const errors = state.errors || [];
                // dispatch(dispatchErrorMsgForClaimAudit(removeErr(errors, [FAILED_MESSAGE_GENERIC])));
              // }, 10000);
            }
      dispatch(dispatchClaimAuditDetail([]));
    });
};

export const dispatchNdcDetails = (data) => ({
  type: actionTypes.GET_NDC_DETAILS,
  payload: data,
});

export const getNdcDetailsCall = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.NDC_DETAILS, values);
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};
// Store claim table actions
export const storeClaimAction = (data) => ({
  type: actionTypes.CLAIM_ACTIONS,
  payload: data,
});

export const getClaimDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CLAIM_DETAILS, value)
    .then((response) => {
      const claimDetailData = {
        [value?.claimId]: response?.data,
      };
      return dispatch(dispatchClaimDetails(claimDetailData));
    })
    .catch((response) => {
      dispatch(dispatchClaimDetails([]));
    });
};

export const dispatchClaimAuditDetails = (data) => ({
  type: actionTypes.CLAIM_AUDIT_DETAILS,
  payload: data,
});

export const dispatchClaimAuditDescription = (data) => ({
  type: actionTypes.CLAIM_AUDIT_DESCRIPTION,
  payload: data,
});

export const getClaimAuditDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.FIND_CLAIM_AUDIT_DETAILS, value)
    .then((response) => {
      const { data } = response;
      const i = data.claimAuditResponse?.map((item) => {
        console.log('fff', item);
        item.uniqueKey = `${item.claimId}-${item.claimLineNum}-${
          item.claimReversalInd || 0
        }`;
        return item;
      });
      // const j = Object.groupBy(i, ({ claimId }) => claimId);
      const groupBy = (array, key) => {
        return array.reduce((result, currentValue) => {
          const groupKey = currentValue[key];
          if (!result[groupKey]) {
            result[groupKey] = [];
          }
          result[groupKey].push(currentValue);
          return result;
        }, {});
      };
      const j = groupBy(i, 'uniqueKey');
      data.claimAuditResponse = Object.keys(j).map((key) => {
        const data = j[key][0];
        data.claimAuditCounts = j[key].length;
        return data;
      });
      return dispatch(dispatchClaimAuditDetails(data));
    })
    .catch((response) => {
      dispatch(dispatchClaimAuditDetails([]));
    });
};

export const getClaimAuditDescription = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CLAIM_AUDIT_DESCRIPTION, value)
    .then((response) => {
      return dispatch(dispatchClaimAuditDescription(response.data));
    })
    .catch((response) => {
      dispatch(dispatchClaimAuditDescription([]));
    });
};

export const dispatchSearchClaim = (data) => ({
  type: actionTypes.SEARCH_CLAIM_LIST,
  payload: data,
});

export const callSearchClaimAPI = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.SEARCH_CLAIM, values);
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const getProviderDetails = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_PROVIDER_DETAILS,
      values
    );
    if (true) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};
export const setClaimAuditDetailTab = (data) => {
  return {
    type: actionTypes.CLAIM_AUDIT_DETAIL_TAB_DATA,
    claimAuditDetailObj: data,
  };
};

export const dispatchUpdateClr = (data) => {
  return {
    type: actionTypes.UPDATE_CLEARED_RESPONSE,
    payload: data,
  };
};

export const updateClearedIndex = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CLEAR_INDEX, value)
    .then((response) => {
      return dispatch(dispatchUpdateClr(response.data));
    })
    .catch((response) => {
      dispatch(dispatchUpdateClr([]));
    });
};

// For pagination value
export const dispatchPageCountwithDetails = (data) => ({
  type: actionTypes.GET_PAGE_COUNT,
  payload: data,
});

export const rowSelected = (val) => {
  return {
    type: actionTypes.ROW_SELECTED,
    payload: val,
  };
};

export const selectedAuditType = (val) => {
  return {
    type: actionTypes.SELECTED_AUDITTYPE,
    payload: val,
  };
};

export const dispatchErrorMessageData = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG_CD,
  payload: data,
});
// dispatch function for cliam audit popup count
export const dispatchClaimAuditPopupCount = (data) => ({
  type: actionTypes.GET_CLAIM_AUDIT_POPUP_COUNT,
  payload: data,
});

// get function call for claim Audit Popup Count Api

export const getClaimAuditPopupCountDataApi = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CLAIM_AUDIT_POPUP_COUNT_S, value)
    .then((response) => {
      return dispatch(dispatchClaimAuditPopupCount(response.data));
    })
    .catch((response) => {
      dispatch(dispatchClaimAuditPopupCount([]));
    });
};

// dispatch function for  Export all on select Scrren
export const dispatchExportAllDetail = (data) => ({
  type: actionTypes.GET_EXPORT_ALL_DETAIL,
  payload: data,
});

export const setExportHandler = (handler) => ({
  type: actionTypes.SET_EXPORT_HANDLER,
  payload: handler,
});

// get function for  Export all on select Scrren
export const getExportAllDetail = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CLAIM_AUDITS_EXPORT_ALL, value)
    .then((response) => {
      return dispatch(dispatchExportAllDetail(response.data));
    })
    .catch((response) => {
      dispatch(dispatchExportAllDetail([]));
    });
};
// dispatch function for  freeze quarter on select Scrren
export const dispatchFreezeQuarter = (data) => ({
  type: actionTypes.GET_FREEZE_QUARTER_FOR_CLAIM_AUDIT,
  payload: data,
});

// get function for  Export all on select Scrren
export const getFreezeQuarterForClaimAudit = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FREEZE_QTR_FOR_CLAIM_AUDITS, value)
    .then((response) => {
      return dispatch(dispatchFreezeQuarter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchFreezeQuarter([]));
    });
};

// clear redux
export const clearReduxForClaimAuditSelectScreen = () => (dispatch) => {
  dispatch(dispatchClaimAuditSelectTabData({}));
  dispatch(
    dispatchErrorMsgForClaimAudit({
      searchScreenErrors: [],
    })
  );
};

// dispatch function for select all changes data list
export const setChangesDataList = (data) => ({
  type: actionTypes.ALL_CHANGES_CLAIM_AUDITS_DATA_LIST,
  changesDataList: data,
});
